<template>
  <tbody
    class="portal-table-body"
    :class="{ 'portal-table-body--loading': loading }"
    :aria-busy="loading ? 'true' : 'false'"
  >
    <template v-if="loading">
      <tr
        v-for="n in rowCount"
        :key="'skeleton-' + n"
        class="portal-skeleton-row"
      >
        <td v-for="c in columnCount" :key="c">
          <span class="portal-skeleton-bar" :class="barClass(c)" />
        </td>
      </tr>
    </template>
    <template v-else>
      <slot />
    </template>
  </tbody>
</template>

<script>
export default {
  name: 'PortalTableBody',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    rowCount: {
      type: Number,
      default: 8,
    },
    /** name-status | airline | user | role | audit | operator */
    variant: {
      type: String,
      required: true,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    columnCount() {
      switch (this.variant) {
        case 'audit':
          return 8;
        case 'operator':
          return 7;
        case 'airline':
          return this.showActions ? 5 : 4;
        case 'user':
          return this.showActions ? 5 : 4;
        case 'role':
          return this.showActions ? 3 : 2;
        case 'name-status':
        default:
          return this.showActions ? 3 : 2;
      }
    },
  },
  methods: {
    barClass(col) {
      switch (this.variant) {
        case 'airline':
          if (col === 2) return 'portal-skeleton-bar--lg';
          if (col === 3) return 'portal-skeleton-bar--logo';
          if (col === 5) return 'portal-skeleton-bar--action';
          return 'portal-skeleton-bar--sm';
        case 'user':
          if (col === 1) return 'portal-skeleton-bar--md';
          if (col === 2) return 'portal-skeleton-bar--lg';
          if (col === 4) return 'portal-skeleton-bar--xl';
          if (col === 5) return 'portal-skeleton-bar--action';
          return 'portal-skeleton-bar--sm';
        case 'role':
          if (col === 2) return 'portal-skeleton-bar--lg';
          if (col === 3) return 'portal-skeleton-bar--action';
          return 'portal-skeleton-bar--sm';
        case 'audit':
          if (col === 4 || col === 5) return 'portal-skeleton-bar--xl';
          if (col === 7) return 'portal-skeleton-bar--md';
          return 'portal-skeleton-bar--sm';
        case 'operator':
          if (col === 1) return 'portal-skeleton-bar--lg';
          if (col === 4) return 'portal-skeleton-bar--md';
          return 'portal-skeleton-bar--sm';
        case 'name-status':
        default:
          if (col === 1) return 'portal-skeleton-bar--lg';
          if (col === 3) return 'portal-skeleton-bar--action';
          return 'portal-skeleton-bar--sm';
      }
    },
  },
};
</script>

<style lang="scss">
.portal-table-body--loading .portal-skeleton-row:hover {
  background-color: inherit;
}

.portal-skeleton-row td {
  padding: 12px 8px;
  vertical-align: middle;
}

.portal-skeleton-bar {
  display: inline-block;
  height: 12px;
  border-radius: 4px;
  max-width: 100%;
  background: linear-gradient(
    90deg,
    hsl(211, 40%, 94%) 0%,
    hsl(211, 50%, 88%) 50%,
    hsl(211, 40%, 94%) 100%
  );
  background-size: 200% 100%;
  animation: portal-skeleton-pulse 1.4s ease-in-out infinite;

  &--sm { width: 56px; }
  &--md { width: 80px; }
  &--lg { width: 140px; }
  &--xl { width: 180px; }
  &--action { width: 72px; }
  &--logo {
    width: 60px;
    height: 40px;
    border-radius: 6px;
  }
}

@keyframes portal-skeleton-pulse {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}
</style>
